<template>
  <v-container fluid v-if="showErrors" class="px-0">
    <el-overlay-loading :loading="loading" />
    <v-card
      :class="'errors-wrapper ma-0 ' + (noErrors ? 'low' : 'high')"
      ref="errorsList"
    >
      <v-card-text class="error-text pa-2 ma-0 ">
        <div class="error-list">
          <v-row no-gutters class="ma-0 pa-0">
            <v-col cols="12" class="text-right pa-0 ma-0"> </v-col>
          </v-row>

          <v-btn
            icon
            small
            class="error-close"
            @click="closeErrors()"
            v-if="!modal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <template v-if="!ntrPaslaugos">
            <h4 class="mb-2">Klaidų sąrašas</h4>
            <v-row
              v-for="(item, i) in errorItems"
              :key="i"
              :class="`error-row type-${item.type}`"
              @click="gotoError(item)"
              no-gutters
            >
              <v-col cols="12" :sm="nameSize" v-if="!textOnly">
                {{ item.name }}
              </v-col>
              <v-col cols="12" :sm="messageSize" class="pr-10">
                {{ item.message }}
              </v-col>
            </v-row>
          </template>

          <template v-if="ntrPaslaugos">
            <template v-if="isNtrError">
              <h4 class="mb-2">Klaidų sąrašas</h4>
              <v-row
                v-for="(item, i) in ntrErrorItems"
                :key="`err-${i}`"
                :class="`error-row type-${item.type} mb-2`"
                @click="gotoError(item)"
                no-gutters
              >
                <v-col cols="12" :sm="nameSize" v-if="!textOnly">
                  {{ item.name }}
                </v-col>
                <v-col cols="12" :sm="messageSize" class="pr-10">
                  {{ item.message }}
                  <span
                    class="linkas"
                    v-if="item.linkas"
                    @click.prevent.stop="gotoLinkas(item.linkas.value)"
                    >{{ item.linkas.text }}</span
                  >
                </v-col>
              </v-row>
            </template>
            <template v-if="isNtrWarning">
              <h4 class="mb-2">Įspėjimai</h4>
              <v-row
                v-for="(item, i) in ntrWarningItems"
                :key="`war-${i}`"
                :class="`error-row type-${item.type}`"
                @click="gotoError(item)"
                no-gutters
              >
                <v-col cols="12" :sm="nameSize" v-if="!textOnly">
                  {{ item.name }}
                </v-col>
                <v-col cols="12" :sm="messageSize" class="pr-10">
                  {{ item.message }}
                </v-col>
              </v-row>
            </template>
            <template v-if="isNtrInfo">
              <v-row
                v-for="(item, i) in ntrInfoItems"
                :key="`war-${i}`"
                :class="`error-row type-${item.type}`"
                @click="gotoError(item)"
                no-gutters
              >
                <v-col cols="12" :sm="nameSize" v-if="!textOnly">
                  {{ item.name }}
                </v-col>
                <v-col cols="12" :sm="messageSize" class="pr-10">
                  {{ item.message }}
                </v-col>
              </v-row>
            </template>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import hipotekaTabs from '@/mixins/hipotekaTabs'
import prasymasTabs from '@/mixins/prasymasTabs'
import sklypasLinkas from '@/mixins/sklypasLinkas'

export default {
  name: 'CheckErrors',
  mixins: [hipotekaTabs, prasymasTabs, sklypasLinkas],
  props: {
    modal: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    textOnly: { type: Boolean, default: false },
    ntrPaslaugos: { type: Boolean, default: false },
  },
  data() {
    return {
      //
    }
  },
  computed: {
    ...mapGetters(['checkErrors', 'hipotekaTipas', 'appSavitarna']),
    isSavitarna() {
      return this.appSavitarna
    },
    tabsList() {
      return this.ntrPaslaugos ? this.prasymasTabs : this.hipotekaTabs
    },
    tabItems() {
      return Object.fromEntries(
        Object.entries(this.tabsList).map(([key, item]) => {
          return [item.errorTab, item]
        })
      )
    },
    tabHipotekaTipas() {
      return this.hipotekaTipas
    },
    errorItems() {
      return this.checkErrors
        ? this.checkErrors.map(item => {
            const linkas = this.parseLinkas(item.message)
            const messageTxt = this.cleanMessage(item.message)

            return {
              ...item,
              name:
                item.title ??
                (this.tabItems[item.tab] ? this.tabItems[item.tab].title : ''),
              route: this.tabItems[item.tab]
                ? this.tabItems[item.tab].route
                : '',
              routeStep: this.tabItems[item.tab]
                ? this.tabItems[item.tab].routeStep ?? null
                : '',
              message: messageTxt,
              linkas: linkas ?? null,
            }
          })
        : []
    },
    showErrors() {
      return this.checkErrors
    },
    errorCount() {
      if (!this.checkErrors) {
        return 0
      }
      return this.checkErrors.filter(item => {
        return item.type === 'error'
      }).length
    },
    noErrors() {
      return this.checkErrors && this.errorCount === 0
    },
    nameSize() {
      return this.modal || (this.ntrPaslaugos && this.isSavitarna) ? 3 : 2
    },
    messageSize() {
      if (this.textOnly) {
        return 12
      }
      return this.modal || (this.ntrPaslaugos && this.isSavitarna) ? 9 : 10
    },
    ntrErrorItems() {
      return this.errorItems
        ? this.errorItems.filter(item => {
            return item.type === 'error'
          })
        : []
    },
    ntrWarningItems() {
      return this.errorItems
        ? this.errorItems.filter(item => {
            return item.type === 'warning'
          })
        : []
    },
    ntrInfoItems() {
      return this.errorItems
        ? this.errorItems.filter(item => {
            return item.type === 'info'
          })
        : []
    },
    isNtrError() {
      return this.ntrErrorItems.length > 0
    },
    isNtrWarning() {
      return this.ntrWarningItems.length > 0
    },
    isNtrInfo() {
      return this.ntrInfoItems.length > 0
    },
  },
  created() {
    //
  },
  methods: {
    gotoError(item) {
      if (this.ntrPaslaugos && this.$route.params.step !== item.routeStep) {
        this.$router.push({
          name: item.route,
          params: { ...this.$route.params, step: item.routeStep },
        })
        return
      }
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
    closeErrors() {
      this.$store.dispatch('checkErrors', null)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';

.errors-wrapper {
  background: #fff;

  &.high {
    border: 1px solid $errorHigh;
  }
  &.low {
    border: 1px solid $errorLow;
  }
}

.error-row {
  cursor: pointer;
  margin-right: 30px;

  &.type-error {
    color: $errorHigh;
  }
  &.type-warning {
    color: $errorMiddle;
  }
  &.type-info {
    color: $errorLow;
  }
}

.error-close {
  position: absolute;
  padding: 0;
  border: none;
  top: 0;
  left: 100%;
  transform: translateX(-60px);
}

.error-list {
  max-height: 260px;
  overflow-y: auto;
}

.linkas {
  font-weight: 600;
  text-decoration: underline;
}
</style>
